/* eslint-disable compat/compat */
export class SwapImageryBasedOnGenderLooksCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.swapGenderImagery()
  }

  swapGenderImagery () {
    const url = new URLSearchParams(window.location.search)

    if (!url.has('gender') && !sessionStorage.getItem('gender')) return

    const gender = url.get('gender')
      ? url.get('gender')
      : sessionStorage.getItem('gender')

    if (gender === 'male') {
      if (
        this.querySelector('.lok-Card_ImageContainer').dataset.genderImages !==
        ''
      ) {
        let genderAltImage = this.querySelector(
          '.lok-Card_ImageContainer',
        ).dataset.genderImages.split(',')[0]

        // get the correct image size
        if (window.innerWidth < 768) {
          const imageSize = window.innerWidth * 2
          genderAltImage = `${genderAltImage}w_${imageSize}`
        } else {
          const imageSize = (window.innerWidth / 2 - 25) * 2
          genderAltImage = `${genderAltImage}w_${imageSize}`
        }
        this.querySelector('.lok-Card_ImageContainer').querySelector(
          'img',
        ).srcset = ''
        this.querySelector('.lok-Card_ImageContainer').querySelector(
          'img',
        ).src = genderAltImage
      }
    }
  }
}

customElements.define(
  'swap-imagery-based-on-gender-looks-card',
  SwapImageryBasedOnGenderLooksCard,
)
